<template>
  <div v-if="allowed">
  <div class="form-group m-form__group" >
    <h5 v-if="labelTitle">{{ labels[labelTitle] }} :</h5>
    <ul>
        <li v-for="file in files">
          <a :href="file.publicPath" download="fff" target="_blank">
            <i class="fa fa-file-download"></i>
            </a> {{ file.name }} <i @click="askBeforeDelete(file)" class="fa fa-times-circle" v-if="withDelete"></i>
        </li>
    </ul>
  </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import { storage, firestoreDB } from '../../assets/js/firebase';
import AlertAction from '../../assets/js/mixins';

export default {
  name: 'ShowFileLinkToObject',
  /**
   * type can be 'projects', 'themes' etc
   * objectId is the id of the object concerned by the upload
   */
  props: ['type', 'objectId', 'labelTitle', 'withDelete'],
  mixins: [AlertAction],
  data() {
    return {
      files: [],
      allowed: false,
      firestoreSnapshot: null,
    };
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels,
    }),
  },
  methods: {
    setfilesLinkToObject() {
      const my = this;

      this.firestoreSnapshot = firestoreDB
        .collection(`files-${process.env.ENV_SHORTNAME}`)
        .where('type', '==', this.type)
        .where('resourceId', '==', this.objectId)
        .orderBy('date', 'asc')
        .onSnapshot({
          includeMetadataChanges: false,
        }, (snapshot) => {
          console.log('updated');
          if (snapshot.docs) {
            const files = snapshot.docs.map((doc) => {
              const file = doc.data();

              file.id = doc.id;

              return file;
            });
            my.files = files;
          }
        });
    },
    askBeforeDelete(file) {
      this.alertAction(this.deleteFile, 'delete_action_warning', file);
    },
    async deleteFile(file) {
      if (this.withDelete) {
        const my = this;

        const listFilesWithSamePath = await firestoreDB.collection(`files-${process.env.ENV_SHORTNAME}`)
          .where('path', '==', file.path)
          .limit(2).get();

        if (listFilesWithSamePath.size > 1) {
          my.deleteFirestoreItem(file);
        } else {
          const myFileRef = storage.ref(file.path);

          myFileRef.delete().then(() => {
            console.log('File deleted successfully', file.id);
            my.deleteFirestoreItem(file);
          }).catch((error) => {
            console.error('Error removing file: ', error);
          });
        }
      }
    },
    deleteFirestoreItem(file) {
      firestoreDB
        .collection(`files-${process.env.ENV_SHORTNAME}`)
        .doc(file.id)
        .delete()
        .then(() => {
          console.log('Document successfully deleted!');
        })
        .catch((error) => {
          console.error('Error removing document: ', error);
        });
    },
  },
  mounted() {
    if (this.allowed) {
      this.setfilesLinkToObject();
    }
  },
  created() {
    const allowedType = [
      'brands',
      'products',
      'ingredients',
      'patents',
      'themes',
      'collections',
      'product_ingredients',
    ];
    if (allowedType.indexOf(this.type) !== -1) {
      this.allowed = true;
    }
  },
  beforeDestroy() {
    console.log('destroy component');
    this.firestoreSnapshot();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Upload/ShowFilesLinkToObject.vue